import { Component, Ref, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { SitePopup } from "../SitePopup/SitePopup";

@Component
export class EnquiryPopup extends ThemeComponent {
    @Ref modalContent!: HTMLElement;
    @Ref modalTrigger!: HTMLButtonElement;
    @Ref closeModal!: HTMLButtonElement;

    private sitePopup: SitePopup|null = document.querySelector('site-popup');

    init() {
        this.sitePopup = document.querySelector('.site-popup') as SitePopup;
        const sitePopupContent = this.sitePopup.querySelector('.site-popup__content');
        const content = this.modalContent;

        this.$listen(this.modalTrigger, 'click', (e) => {
            e.preventDefault();
            sitePopupContent?.append(content);
            if (!this.sitePopup) { return; }
            this.sitePopup.open('find-a-box');
        });

        this.$listen(this.closeModal, 'click', () => {
            this.sitePopup?.close();
        });
    }
}
